export default {
  url: process.env.VUE_APP_API_URL || 'https://djisamsoe-api.antigravity.dev',
};
